import { EMediaType, ESizeType, Product } from "#models/product";
import { Dictionary } from "#models/questionnaire";
import React from 'react';

export function getImageOriginal(product: Product) {
  if (product?.media?.length) {
    const file = product.media.find((m) => m.mediaType == EMediaType.Image);
    if (file && file.mediaFiles.length) {
      const mediaFile = file.mediaFiles.find((m) => m.sizeType == ESizeType.Original);
      return mediaFile?.url || '';
    }
  }
  return '';
}

export const getThumbnailImage = (product: Product) =>
  React.useMemo(() => {
    if (product.media.length) {
      const thumbnailImages = product.media.filter((m) => m.mediaType === EMediaType.Image);
      return thumbnailImages.map((item) => item.mediaFiles?.find((m) => m.sizeType === ESizeType.Original)?.url || '');
    }
    return [];
  }, [product]);

const CurrencyMap: Dictionary = {
  UK: 'GBP',
  US: 'USD',
  Euro: 'EUR',
  EU: 'EUR',
  SA: 'ZAR'
};

export function toProductCurrency(amount: string | number, currencyName = 'Euro'): string {
  if (isNaN(+amount)) {
    return '';
  }
  return new Intl.NumberFormat(currencyName !== 'SA' ? 'en-US' : 'en-za', {
    style: 'currency',
    currency: CurrencyMap[currencyName] || ''
  })
    .format(+amount)
    .replace(/\D00(?=\D*$)/, '');
}

export function getVideoOriginal(product: Product) {
  if (product.media.length) {
    const file = product.media.find((m) => m.mediaType === EMediaType.Video);
    if (file && file.mediaFiles && file.mediaFiles.length) {
      const mediaFile = file.mediaFiles[0];
      return mediaFile?.url || '';
    }
  }
  return '';
}
